// Shared vertical spacing between home sections and section content.
export const SECTION_SPACING = '1rem';
